export default {
  "content": "<path d=\"M368.53 64v163.52L96 64v384l272.53-163.52V448H416V64h-47.47z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};